import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ElementRef
} from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'
import * as _ from 'lodash'

const noop = () => {}

@Component({
  selector: 'rating-control',
  template: require('./rating-control.component.html'),
  styles: [require('./rating-control.component.sass')],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RatingControlComponent),
    multi: true
  }]
})
export class RatingControlComponent implements ControlValueAccessor {

  @Input('value')
  @Input() inputClass: string

  @Output('select') private onSelectEmitter: EventEmitter<Object> = new EventEmitter<Object>()

  MAX = 5
  MIN = 0
  STEP = 0.1
  private rating: number
  private onTouchedCallback: () => void = noop
  private onChangeCallback: (_: any) => void = noop

  constructor(private elRef: ElementRef) { }

  writeValue(v: any) {
    this.rating = v
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn
  }

  get value(): any {
    return this.rating
  }

  set value(v) {
    this.select(v)
  }

  private select(v) {
    this.rating = v
    this.onChangeCallback(v)
    this.onSelectEmitter.emit(this.rating)
  }

  private keyup(event) {
    if (isNaN(Number(event.key))) return
    
    let val = Number(event.target.value)
    if (val > this.MAX) val = this.MAX
    if (val < this.MIN) val = this.MIN
    this.select(val)
  }

  private change(ev) {
    this.select(Number(ev.target.value))
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/rating-control.component.ts